module.exports = __webpack_public_path__ + "u2f_38x38.ddb01326984e01d7fa8c07f20f844f6d.png";